/* eslint-disable no-unused-vars */
import { connect } from 'react-redux';
import { constant } from '../../../Utils/constants';
import React, { Fragment, useState, useEffect } from 'react';
import translation from '../../../../../commons/translation';
import InputComponent from '../../../Widgets/InputComponent';

import InputNumberComponent from '../../../Widgets/InputNumberComponent';
import { DeleteOutlined, QuestionCircleOutlined } from '@ant-design/icons';
import { Form, Select, Popconfirm, Collapse, Tooltip, message, Checkbox, Button } from 'antd';
import {
  getToolsList,
  getLaborList,
  getMaterialsList,
  checkAvailability,
  getItemsList,
  _getUOMList,
  getUsersList,
  getSkillTypeList
} from '../../../Utils/FormCalls';

const { Option } = Select;
const { Panel } = Collapse;

const ToolsformFunction = (props) => {
  const [toolsList, setTool] = useState([]);
  const [translationCache, settranslationCache] = useState(props.translationCache || {});
  useEffect(() => {
    (async () => {
      try {
        let response = await getToolsList();
        setTool(response.data);
      } catch (e) {
        return {};
      }
    })();
  }, []);
  return (
    <Form.List name={[props.fieldKey, 'Tools']}>
      {(Tools, { add, remove }) => {
        return (
          <Fragment>
            <Form.Item>
              <div style={{ display: 'flex', justifyContent: 'right' }}>
                <Button
                  type="dashed"
                  style={{ background: '#29415a', color: '#fff' }}
                  onClick={() => {
                    add();
                  }}
                >
                  {' '}
                  {translation(translationCache, constant.addTools)}{' '}
                </Button>
              </div>
            </Form.Item>
            {Tools && Array.isArray(Tools) && Tools.length > 0 ? (
              <Collapse accordion defaultActiveKey={[]}>
                {Tools.map((tool, index2) => (
                  <Panel
                    key={index2}
                    header={`${translation(translationCache, constant.tools)} ${index2 + 1}`}
                    extra={
                      <Popconfirm
                        title={translation(translationCache, constant.deleteTool)}
                        icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
                        onConfirm={() => remove(tool.name)}
                        okText={translation(translationCache, constant.yes)}
                        cancelText={translation(translationCache, constant.no)}
                      >
                        <Tooltip title={translation(translationCache, 'Delete')} placement="bottom">
                          <DeleteOutlined />
                        </Tooltip>
                      </Popconfirm>
                    }
                  >
                    <>
                      <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                        <Form.Item
                          style={{ flex: '50%' }}
                          labelCol={{ flex: '130px' }}
                          label={translation(translationCache, constant.tool)}
                          {...tool}
                          name={[tool.name, 'ToolId']}
                          fieldKey={[tool.fieldKey, 'ToolId']}
                          key={index2}
                          rules={[{ required: true, message: 'tool Missing' }]}
                        >
                          <Select
                            style={{ width: '90%' }}
                            onChange={(value) =>
                              props.onToolChange(
                                value,
                                props.fieldKey,
                                tool.key,
                                'Tools',
                                toolsList.filter((tool) => tool.Id === value)
                              )
                            }
                            placeholder={translation(translationCache, 'Select Tool')}
                          >
                            {toolsList.map((tool, index) => {
                              return (
                                <Option key={index} value={tool.Id}>
                                  {' '}
                                  {tool.Tool}{' '}
                                </Option>
                              );
                            })}
                          </Select>
                        </Form.Item>
                        <Form.Item
                          label={translation(translationCache, constant.description)}
                          {...tool}
                          style={{ flex: '50%' }}
                          labelCol={{ flex: '130px' }}
                          name={[tool.name, 'Description']}
                          fieldKey={[tool.fieldKey, 'Description']}
                          key={index2}
                          rules={[{ required: false, message: 'Value Missing' }]}
                        >
                          <InputComponent
                            placeholder={translation(translationCache, 'Description')}
                            style={{ width: '90%' }}
                            disabled
                          />
                        </Form.Item>
                        <Form.Item
                          // label={translation(translationCache, constant.availableQuantity)}
                          // disabled={true}
                          // {...tool}
                          // style={{ flex: '50%' }}
                          // labelCol={{ flex: '130px' }}
                          name={[tool.name, 'AvailableQuantity']}
                        // fieldKey={[tool.fieldKey, 'AvailableQuantity']}
                        // key={index2}
                        // rules={[{ required: false, message: 'Value Missing' }]}
                        >
                          {/* <InputComponent
                            disabled={true}
                            placeholder={translation(translationCache, 'Total Quantity')}
                            style={{ width: '90%' }}
                          /> */}
                        </Form.Item>
                        <Form.Item
                          label={translation(translationCache, constant.Quantity)}
                          validateTrigger={['onChange', 'onBlur']}
                          {...tool}
                          name={[tool.name, 'Quantity']}
                          fieldKey={[tool.fieldKey, 'Quantity']}
                          key={index2}
                          style={{ flex: '50%' }}
                          labelCol={{ flex: '130px' }}
                          rules={[
                            {
                              required: true,
                              validator: (_, value) => {
                                if (value === undefined || value === '') {
                                  return Promise.reject('Please Input Numbers Only');
                                }
                                if (!/^\d+$/.test(value)) {
                                  return Promise.reject('Please Input Numbers Only');
                                }
                                return Promise.resolve();
                              }
                            }
                          ]}
                        >
                          <InputNumberComponent
                            // min={0}
                            // max={1000}
                            placeholder={translation(translationCache, 'Quantity')}
                            style={{ width: '90%' }}
                            addonAfter={
                              <Tooltip
                                style={{ marginRight: '20px', flex: '50%' }}
                                labelCol={{ flex: '130px' }}
                                title={translation(
                                  translationCache,
                                  'AvailableQuantity  -  ' +
                                  (props &&
                                    props.formObject &&
                                    props.formObject.TaskData &&
                                    props.formObject.TaskData[index2] &&
                                    props.formObject.TaskData[index2].Tools &&
                                    props.formObject.TaskData[index2].Tools[index2] &&
                                    props.formObject.TaskData[index2].Tools[index2].AvailableQuantity
                                    ? props.formObject.TaskData[index2].Tools[index2].AvailableQuantity
                                    : 'Not Available')
                                )}
                              >
                                <QuestionCircleOutlined />
                              </Tooltip>
                            }
                          />
                        </Form.Item>
                        <Form.Item
                          style={{ flex: '50%' }}
                          labelCol={{ flex: '130px' }}
                          {...tool}
                        ></Form.Item>
                      </div>
                    </>
                  </Panel>
                ))}
              </Collapse>
            ) : null}
          </Fragment>
        );
      }}
    </Form.List>
  );
};

const LaborFormFunction = (props) => {
  const [laborsList, setLabor] = useState([]);
  const [skill, setSkill] = useState([]);
  const [translationCache, settranslationCache] = useState(props.translationCache || {});
  useEffect(() => {
    (async () => {
      try {
        let response = await getLaborList();
        setLabor(response.data);
      } catch (e) {
        return {};
      }
      try {
        let SkilTypeList = await getSkillTypeList();
        setSkill(SkilTypeList);
      } catch (e) {
        return {};
      }
    })();
  }, []);
  return (
    <div>
      <Form.List name={[props.fieldKey, 'Labor']}>
        {(Labor, { add, remove }) => {
          return (
            <Fragment>
              <Form.Item>
                <div style={{ display: 'flex', justifyContent: 'right' }}>
                  <Button
                    type="dashed"
                    style={{ background: '#29415a', color: '#fff' }}
                    onClick={() => {
                      add();
                    }}
                  >
                    {translation(translationCache, constant.addLabor)}{' '}
                  </Button>{' '}
                </div>
              </Form.Item>
              {Labor && Array.isArray(Labor) && Labor.length > 0 ? (
                <Collapse accordion defaultActiveKey={[]}>
                  {Labor.map((labor, index2) => (
                    <Panel
                      key={index2}
                      header={`${translation(translationCache, constant.labor)} ${index2 + 1}`}
                      extra={
                        <Popconfirm
                          title={translation(translation, constant.deleteTool1)}
                          icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
                          onConfirm={() => remove(labor.name)}
                          okText={translation(translationCache, constant.yes)}
                          cancelText={translation(translationCache, constant.no)}
                        >
                          <Tooltip
                            title={translation(translationCache, 'Delete')}
                            placement="bottom"
                          >
                            <DeleteOutlined />
                          </Tooltip>
                        </Popconfirm>
                      }
                    >
                      <>
                        <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                          <Form.Item
                            style={{ flex: '50%' }}
                            labelCol={{ flex: '130px' }}
                            label={translation(translationCache, constant.labor)}
                            {...labor}
                            name={[labor.name, 'LaborId']}
                            fieldKey={[labor.fieldKey, 'LaborId']}
                            key={index2}
                            rules={[{ required: true, message: 'Labor required' }]}
                          >
                            <Select
                              style={{ width: '90%' }}
                              onChange={(value) =>
                                props.onLaborChange(
                                  value,
                                  props.fieldKey,
                                  labor.key,
                                  'Labor',
                                  laborsList.filter((laborItem) => laborItem.Id === value)
                                )
                              }
                              placeholder={translation(translationCache, 'Select Manpower')}
                            >
                              {laborsList &&
                                Array.isArray(laborsList) &&
                                laborsList.map((labor, index) => {
                                  return (
                                    <Option key={index} value={labor.Id}>
                                      {' '}
                                      {labor.FirstName}{' '}
                                    </Option>
                                  );
                                })}
                            </Select>
                          </Form.Item>
                          <Form.Item
                            name={[labor.name, 'AvailableQuantity']}
                          >
                          </Form.Item>
                          <Form.Item
                            style={{ flex: '50%' }}
                            labelCol={{ flex: '130px' }}
                            label={translation(translationCache, constant.Skill)}
                            {...labor}
                            name={[labor.name, 'SkillTypeId']}
                            fieldKey={[labor.fieldKey, 'SkillTypeId']}
                            key={index2}
                            rules={[{ required: false, message: 'SkillType Missing' }]}
                          >
                            <InputComponent
                              placeholder={translation(
                                translationCache,
                                'AutoPopulate from Manpower'
                              )}
                              style={{ width: '90%' }}
                              disabled
                            />
                          </Form.Item>
                          <Form.Item
                            style={{ flex: '50%' }}
                            labelCol={{ flex: '130px' }}
                            label={translation(translationCache, constant.Quantity)}
                            validateTrigger={['onChange', 'onBlur']}
                            {...labor}
                            name={[labor.name, 'Quantity']}
                            fieldKey={[labor.fieldKey, 'Quantity']}
                            key={index2}
                            rules={[
                              {
                                required: true,
                                validator: (_, value) => {
                                  if (value === undefined || value === '') {
                                    return Promise.reject('Please Input Numbers Only');
                                  }
                                  if (!/^\d+$/.test(value)) {
                                    return Promise.reject('Please Input Numbers Only');
                                  }
                                  return Promise.resolve();
                                }
                              }
                            ]}
                          >
                            <InputNumberComponent
                              placeholder={translation(translationCache, 'Quantity')}
                              style={{ width: '90%' }}
                              addonAfter={
                                <Tooltip
                                  style={{ marginRight: '20px', flex: '50%' }}
                                  labelCol={{ flex: '130px' }}
                                  title={translation(
                                    translationCache,
                                    'AvailableQuantity  -  ' +
                                    (props &&
                                      props.formObject &&
                                      props.formObject.TaskData &&
                                      props.formObject.TaskData[index2] &&
                                      props.formObject.TaskData[index2].Labor &&
                                      props.formObject.TaskData[index2].Labor[index2] &&
                                      props.formObject.TaskData[index2].Labor[index2].AvailableQuantity
                                      ? props.formObject.TaskData[index2].Labor[index2].AvailableQuantity
                                      : 'Not Available')
                                  )}
                                >
                                  <QuestionCircleOutlined />
                                </Tooltip>
                              }
                            />
                          </Form.Item>
                          <Form.Item style={{ width: '100%', flex: '50%' }}>
                            <InputComponent style={{ display: 'none' }} />
                          </Form.Item>
                        </div>
                      </>
                    </Panel>
                  ))}
                </Collapse>
              ) : null}
            </Fragment>
          );
        }}
      </Form.List>
    </div>
  );
};

const MaterialFormFunction = (props) => {
  const [materialsList, setTool] = useState([]);
  const [translationCache, settranslationCache] = useState(props.translationCache || {});
  useEffect(() => {
    (async () => {
      try {
        let response = await getMaterialsList();
        setTool(response.data);
      } catch (e) {
        return {};
      }
    })();
  }, []);
  return (
    <div>
      <Form.List name={[props.fieldKey, 'Materials']}>
        {(Material, { add, remove }) => {
          return (
            <Fragment>
              <Form.Item>
                <div style={{ display: 'flex', justifyContent: 'right' }}>
                  <Button
                    type="dashed"
                    style={{ background: '#29415a', color: '#fff' }}
                    onClick={() => {
                      add();
                    }}
                  >
                    {translation(translationCache, constant.addMaterial)}{' '}
                  </Button>
                </div>
              </Form.Item>
              {Material && Array.isArray(Material) && Material.length > 0 ? (
                <Collapse accordion defaultActiveKey={[]}>
                  {Material.map((material, index2) => (
                    <Panel
                      key={index2}
                      header={`${translation(translationCache, constant.material)} ${index2 + 1}`}
                      extra={
                        <Popconfirm
                          title={translation(translationCache, constant.deleteLabor1)}
                          icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
                          onConfirm={() => remove(material.name)}
                          okText={translation(translationCache, constant.yes)}
                          cancelText={translation(translationCache, constant.no)}
                        >
                          <Tooltip
                            title={translation(translationCache, 'Delete')}
                            placement="bottom"
                          >
                            <DeleteOutlined />
                          </Tooltip>
                        </Popconfirm>
                      }
                    >
                      <>
                        <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                          <Form.Item
                            style={{ flex: '50%' }}
                            labelCol={{ flex: '130px' }}
                            label={translation(translationCache, constant.material)}
                            {...material}
                            name={[material.name, 'MaterialId']}
                            fieldKey={[material.fieldKey, 'MaterialId']}
                            key={index2}
                            rules={[{ required: true, message: 'Material is required' }]}
                          >
                            <Select
                              style={{ width: '90%' }}
                              onChange={(value) =>
                                props.onMaterialChange(
                                  value,
                                  props.fieldKey,
                                  material.key,
                                  'Materials',
                                  materialsList.filter((Item) => Item.Id === value)
                                )
                              }
                              placeholder={translation(translationCache, 'Select MaterialId')}
                            >
                              {materialsList.map((material, index) => {
                                return (
                                  <Option key={index} value={material.Id}>
                                    {' '}
                                    {material.Material}{' '}
                                  </Option>
                                );
                              })}
                            </Select>
                          </Form.Item>
                          <Form.Item
                            style={{ flex: '50%' }}
                            labelCol={{ flex: '130px' }}
                            label={translation(translationCache, constant.description)}
                            {...material}
                            name={[material.name, 'Description']}
                            fieldKey={[material.fieldKey, 'Description']}
                            key={index2}
                            rules={[{ required: false, message: 'Value Missing' }]}
                          >
                            <InputComponent
                              placeholder={translation(translationCache, 'Description')}
                              style={{ width: '90%' }}
                              disabled
                            />
                          </Form.Item>
                          <Form.Item
                            name={[material.name, 'AvailableQuantity']}
                          >
                          </Form.Item>
                          <Form.Item
                            style={{ flex: '50%' }}
                            labelCol={{ flex: '130px' }}
                            label={translation(translationCache, constant.Quantity)}
                            validateTrigger={['onChange', 'onBlur']}
                            {...material}
                            name={[material.name, 'Quantity']}
                            fieldKey={[material.fieldKey, 'Quantity']}
                            key={index2}
                            rules={[
                              {
                                required: true,
                                validator: (_, value) => {
                                  if (value === undefined || value === '') {
                                    return Promise.reject('Please Input Numbers Only');
                                  }
                                  if (!/^\d+$/.test(value)) {
                                    return Promise.reject('Please Input Numbers Only');
                                  }
                                  return Promise.resolve();
                                }
                              }
                            ]}
                          >
                            <InputNumberComponent
                              placeholder={translation(translationCache, 'Quantity')}
                              style={{ width: '90%' }}
                              addonAfter={
                                <Tooltip
                                  style={{ marginRight: '20px', flex: '50%' }}
                                  labelCol={{ flex: '130px' }}
                                  title={translation(
                                    translationCache,
                                    'AvailableQuantity  -  ' +
                                    (props &&
                                      props.formObject &&
                                      props.formObject.TaskData &&
                                      props.formObject.TaskData[index2] &&
                                      props.formObject.TaskData[index2].Materials &&
                                      props.formObject.TaskData[index2].Materials[index2] &&
                                      props.formObject.TaskData[index2].Materials[index2].AvailableQuantity
                                      ? props.formObject.TaskData[index2].Materials[index2].AvailableQuantity
                                      : 'Not Available')
                                  )}
                                >
                                  <QuestionCircleOutlined />
                                </Tooltip>
                              }
                            />
                          </Form.Item>
                          <Form.Item
                            style={{ flex: '50%' }}
                            labelCol={{ flex: '130px' }}
                          ></Form.Item>
                        </div>
                      </>
                    </Panel>
                  ))}
                </Collapse>
              ) : null}
            </Fragment>
          );
        }}
      </Form.List>
    </div>
  );
};

const ItemFormFunction = (props) => {
  const [itemsList, setItem] = useState([]);
  const [translationCache, settranslationCache] = useState(props.translationCache || {});
  useEffect(() => {
    (async () => {
      try {
        let response = await getItemsList();
        setItem(response.data);
      } catch (e) {
        return {};
      }
    })();
  }, []);
  return (
    <Form.List name={[props.fieldKey, 'Items']}>
      {(Items, { add, remove }) => {
        return (
          <Fragment>
            <Form.Item>
              <div style={{ display: 'flex', justifyContent: 'right' }}>
                <Button
                  type="dashed"
                  style={{ background: '#29415a', color: '#fff' }}
                  onClick={() => {
                    add();
                  }}
                >
                  {translation(translationCache, constant.addItem)}{' '}
                </Button>
              </div>
            </Form.Item>
            {Items && Array.isArray(Items) && Items.length > 0 ? (
              <Collapse accordion defaultActiveKey={[]}>
                {Items.map((item, index2) => (
                  <Panel
                    key={index2}
                    header={`${translation(translationCache, constant.item)} ${index2 + 1}`}
                    extra={
                      <Popconfirm
                        title={translation(translationCache, constant.deleteItem)}
                        icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
                        onConfirm={() => remove(item.name)}
                        okText={translation(translationCache, constant.yes)}
                        cancelText={translation(translationCache, constant.no)}
                      >
                        <Tooltip title={translation(translationCache, 'Delete')} placement="bottom">
                          <DeleteOutlined />
                        </Tooltip>
                      </Popconfirm>
                    }
                  >
                    <>
                      <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                        <Form.Item
                          style={{ flex: '50%' }}
                          labelCol={{ flex: '130px' }}
                          label={translation(translationCache, constant.item)}
                          {...item}
                          name={[item.name, 'ItemId']}
                          fieldKey={[item.fieldKey, 'ItemId']}
                          key={index2}
                          rules={[{ required: true, message: 'item Missing' }]}
                        >
                          <Select
                            style={{ width: '90%' }}
                            onChange={(value) =>
                              props.onItemChange(
                                value,
                                props.fieldKey,
                                item.key,
                                'Items',
                                itemsList.filter((tool) => tool.Id === value)
                              )
                            }
                            placeholder={translation(translationCache, 'Select Item')}
                          >
                            {itemsList.map((item, index) => {
                              return (
                                <Option key={index} value={item.Id}>
                                  {' '}
                                  {translation(translationCache, item.Item)}{' '}
                                </Option>
                              );
                            })}
                          </Select>
                        </Form.Item>
                        <Form.Item
                          style={{ flex: '50%' }}
                          labelCol={{ flex: '130px' }}
                          label={translation(translationCache, constant.description)}
                          {...item}
                          name={[item.name, 'Description']}
                          fieldKey={[item.fieldKey, 'Description']}
                          key={index2}
                          rules={[{ required: false, message: 'Value Missing' }]}
                        >
                          <InputComponent
                            placeholder={translation(translationCache, 'Description')}
                            style={{ width: '90%' }}
                            disabled
                          />
                        </Form.Item>
                        <Form.Item
                          name={[item.name, 'AvailableQuantity']}
                        >
                        </Form.Item>
                        <Form.Item
                          style={{ flex: '50%' }}
                          labelCol={{ flex: '130px' }}
                          label={translation(translationCache, constant.Quantity)}
                          validateTrigger={['onChange', 'onBlur']}
                          {...item}
                          name={[item.name, 'Quantity']}
                          fieldKey={[item.fieldKey, 'Quantity']}
                          key={index2}
                          rules={[
                            {
                              required: true,
                              validator: (_, value) => {
                                if (value === undefined || value === '') {
                                  return Promise.reject('Please Input Numbers Only');
                                }
                                if (!/^\d+$/.test(value)) {
                                  return Promise.reject('Please Input Numbers Only');
                                }
                                return Promise.resolve();
                              }
                            }
                          ]}
                        >
                          <InputNumberComponent
                            placeholder={translation(translationCache, 'Quantity')}
                            style={{ width: '90%' }}
                            addonAfter={
                              <Tooltip
                                style={{ marginRight: '20px', flex: '50%' }}
                                labelCol={{ flex: '130px' }}
                                title={translation(
                                  translationCache,
                                  'AvailableQuantity  -  ' +
                                  (props &&
                                    props.formObject &&
                                    props.formObject.TaskData &&
                                    props.formObject.TaskData[index2] &&
                                    props.formObject.TaskData[index2].Items &&
                                    props.formObject.TaskData[index2].Items[index2] &&
                                    props.formObject.TaskData[index2].Items[index2].AvailableQuantity
                                    ? props.formObject.TaskData[index2].Items[index2].AvailableQuantity
                                    : 'Not Available')
                                )}
                              >
                                <QuestionCircleOutlined />
                              </Tooltip>
                            }
                          />
                        </Form.Item>
                        <Form.Item
                          style={{ flex: '50%' }}
                          labelCol={{ flex: '130px' }}
                          {...item}
                        ></Form.Item>
                      </div>
                    </>
                  </Panel>
                ))}
              </Collapse>
            ) : null}
          </Fragment>
        );
      }}
    </Form.List>
  );
};

const FieldDataTypeFormFunction = (props) => {
  const translationCache = props.translationCache || {};
  const [usersList, setUsersList] = useState([]);
  const [uomList, setUomList] = useState([]);
  const [formObject, setFormObject] = useState(props.formObject);
  const [fileUploadList, setFileUploadList] = useState({});
  const [Include, setInclude] = useState(props.Include);
  const AddInclude = props.AddTask;
  const workOrderJobPlanRef = props.workOrderJobPlanRef;
  const index = props.checkbox;

  useEffect(() => {
    (async () => {
      try {
        const usersList = await getUsersList();
        setUsersList(usersList);
      } catch (error) {
        message.warn(`${error.message}`);
      }
      try {
        const uomList = await _getUOMList();
        setUomList(uomList);
      } catch (error) {
        message.warn(`${error.message}`);
      }
    })();
  }, []);

  return (
    <Form.List name={[props.fieldKey, 'FieldDataType']}>
      {(FieldDataType, { add, remove }) => {
        return (
          <Fragment>
            <Form.Item>
              <div style={{ display: 'flex', justifyContent: 'right' }}>
                <Button
                  type="dashed"
                  style={{ background: '#29415a', color: '#fff' }}
                  onClick={() => {
                    add();
                    if (AddInclude === true) {
                      setInclude(false);
                    } else {
                      setInclude(true);
                    }
                  }}
                >
                  {translation(translationCache, constant.addTasks)}
                </Button>
              </div>
            </Form.Item>
            {FieldDataType && Array.isArray(FieldDataType) && FieldDataType.length > 0 ? (
              <Collapse accordion defaultActiveKey={[]}>
                {FieldDataType &&
                  Array.isArray(FieldDataType) &&
                  FieldDataType.map((item, index2) => {
                    return (
                      <Panel
                        key={index2}
                        header={
                          <div style={{ fontWeight: 'bold' }}>
                            {`${translation(translationCache, constant.FieldDataType)} ${index2 + 1
                              }`}
                          </div>
                        }
                        extra={
                          <Popconfirm
                            title={translation(translationCache, constant.deleteFdt)}
                            icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
                            onConfirm={() => remove(item.name)}
                            okText={translation(translationCache, constant.yes)}
                            cancelText={translation(translationCache, constant.no)}
                          >
                            <Tooltip
                              title={translation(translationCache, 'Delete')}
                              placement="bottom"
                            >
                              <DeleteOutlined />
                            </Tooltip>
                          </Popconfirm>
                        }
                      >
                        <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                          <Form.Item
                            label={translation(translationCache, constant.Taskitem)}
                            style={{ flex: '50%' }}
                            labelCol={{ flex: '130px' }}
                            {...item}
                            name={[item.name, 'Name']}
                            fieldKey={[item.fieldKey, 'Name']}
                            key={index2}
                            rules={[
                              {
                                required: true,
                                message: 'Task Item is Required'
                              }
                            ]}
                          >
                            <InputComponent
                              placeholder={translation(translationCache, 'Enter Task')}
                              style={{ width: '90%' }}
                            />
                          </Form.Item>
                          <Form.Item
                            label={translation(translationCache, 'Task Description')}
                            {...item}
                            style={{ flex: '50%' }}
                            labelCol={{ flex: '130px' }}
                            name={[item.name, 'Description']}
                            fieldKey={[item.fieldKey, 'Description']}
                            key={index2}
                            rules={[
                              {
                                required: true,
                                message: 'Task Description is Required'
                              }
                            ]}
                          >
                            <InputComponent
                              placeholder={translation(translationCache, 'Enter Description')}
                              style={{ width: '90%' }}
                              disabled
                            />
                          </Form.Item>

                          <Form.Item
                            label={translation(translationCache, 'Measurement Value')}
                            {...item}
                            style={{ flex: '50%' }}
                            labelCol={{ flex: '130px' }}
                            name={[item.name, 'MeasurementValue']}
                            fieldKey={[item.fieldKey, 'MeasurementValue']}
                            key={index2}
                          >
                            <InputComponent
                              placeholder={translation(translationCache, 'Enter Measurement Value')}
                              style={{ width: '90%' }}
                            />
                          </Form.Item>
                          <Form.Item
                            label={translation(translationCache, 'Unit Of Measure ')}
                            {...item}
                            style={{ flex: '50%' }}
                            labelCol={{ flex: '130px' }}
                            name={[item.name, 'UOM']}
                            fieldKey={[item.fieldKey, 'UOM']}
                            key={index2}
                          >
                            <Select
                              placeholder={translation(translationCache, 'Select UOM')}
                              style={{ width: '90%' }}
                            >
                              {uomList &&
                                Array.isArray(uomList) &&
                                uomList.map((uom, index) => {
                                  return (
                                    <Option key={index} value={uom.UOM}>
                                      {' '}
                                      {uom.UOM}{' '}
                                    </Option>
                                  );
                                })}
                            </Select>
                          </Form.Item>
                          <Form.Item
                            // style={{ width: '100%', flex: '50%' }}
                            label={translation(translationCache, constant.inspectionMethod)}
                            {...item}
                            style={{ flex: '50%' }}
                            labelCol={{ flex: '130px' }}
                            name={[item.name, 'Method']}
                            fieldKey={[item.fieldKey, 'Method']}
                            key={index2}
                          >
                            <InputComponent
                              placeholder={translation(translationCache, 'Enter Inspection Method')}
                              // value={formObject.InspectionMethod}
                              style={{ width: '90%' }}
                            //maxLength={30}
                            />
                          </Form.Item>
                          <Form.Item
                            label={translation(translationCache, constant.criterion)}
                            {...item}
                            style={{ flex: '50%' }}
                            labelCol={{ flex: '130px' }}
                            name={[item.name, 'Criteria']}
                            fieldKey={[item.fieldKey, 'Criteria']}
                            key={index2}
                          >
                            <InputComponent
                              placeholder={translation(translationCache, 'Enter Criteria')}
                              // value={formObject.Criteria}
                              style={{ width: '90%' }}
                            //maxLength={30}
                            />
                          </Form.Item>
                          <Form.Item
                            label={translation(translationCache, constant.observation)}
                            {...item}
                            style={{ flex: '50%' }}
                            labelCol={{ flex: '130px' }}
                            name={[item.name, 'Observation']}
                            fieldKey={[item.fieldKey, 'Observation']}
                            key={index2}
                          >
                            <InputComponent
                              placeholder={translation(translationCache, 'Enter Observation')}
                              style={{ width: '90%' }}
                            />
                          </Form.Item>
                          <Form.Item
                            label={translation(translationCache, constant.recordedBy)}
                            style={{ flex: '50%' }}
                            labelCol={{ flex: '130px' }}
                            {...item}
                            name={[item.name, 'RecordBy']}
                            fieldKey={[item.fieldKey, 'RecordBy']}
                            key={index2}
                          >
                            <Select
                              placeholder={translation(translationCache, 'Select RecordedBy')}
                              style={{ width: '90%' }}
                            >
                              {usersList &&
                                Array.isArray(usersList) &&
                                usersList.length > 0 &&
                                usersList.map((item, index) => {
                                  return (
                                    <Option key={index} value={item.Id}>
                                      {' '}
                                      {item.FirstName}{' '}
                                    </Option>
                                  );
                                })}
                            </Select>
                          </Form.Item>
                          {/* <Form.Item
                            style={{ flex: '50%' }}
                            labelCol={{ flex: '130px' }}
                            {...FieldDataType}
                          ></Form.Item> */}
                          {formObject &&
                            formObject.TaskData &&
                            formObject.TaskData[index] &&
                            formObject.TaskData[index].Id && (
                              <>
                                <Form.Item
                                  style={{ marginLeft: '110px' }}
                                  // labelCol={{ marginLeft:'100px' }}
                                  {...item}
                                  name={[item.name, 'AddJobplan']}
                                  valuePropName="checked"
                                >
                                  <Checkbox>
                                    {translation(translationCache, 'Include in JobPlan')}
                                  </Checkbox>
                                </Form.Item>

                                <Form.Item
                                  style={{ marginLeft: '350px' }}
                                  // labelCol={{ flex: '130px' }}
                                  {...item}
                                  name={[item.name, 'AddTask']}
                                  valuePropName="checked"
                                >
                                  <Checkbox>
                                    {translation(translationCache, 'Include in Task')}
                                  </Checkbox>
                                </Form.Item>
                              </>
                            )}
                        </div>
                      </Panel>
                    );
                  })}
              </Collapse>
            ) : null}
          </Fragment>
        );
      }}
    </Form.List>
  );
};

const mapStateToProps = (state) => {
  return {
    translationCache: state.TranslationReducer.translationCache,
  };
};
const Toolsform = connect(mapStateToProps)(ToolsformFunction);
const LaborForm = connect(mapStateToProps)(LaborFormFunction);
const MaterialForm = connect(mapStateToProps)(MaterialFormFunction);
const ItemForm = connect(mapStateToProps)(ItemFormFunction);
const FieldTypeForm = connect(mapStateToProps)(FieldDataTypeFormFunction);

export { Toolsform, LaborForm, MaterialForm, ItemForm, FieldTypeForm };
